import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const pos = { x: -100, y: -100 };
    const ring = { x: -100, y: -100 };
    let hovered = false;
    let rafId;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`;
      }
    };
    const onOver = (e) => {
      hovered = !!e.target.closest("a, button, input, textarea, [data-hover]");
    };
    const loop = () => {
      ring.x += (pos.x - ring.x) * 0.14;
      ring.y += (pos.y - ring.y) * 0.14;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ring.x}px, ${ring.y}px) translate(-50%, -50%) scale(${
          hovered ? 2 : 1
        })`;
        ringRef.current.style.opacity = hovered ? "0.9" : "0.5";
      }
      rafId = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    rafId = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div
        ref={ringRef}
        aria-hidden="true"
        className="fixed top-0 left-0 z-[199] w-9 h-9 rounded-full border border-brass pointer-events-none hidden md:block"
        style={{ opacity: 0 }}
      />
      <div
        ref={dotRef}
        aria-hidden="true"
        className="fixed top-0 left-0 z-[200] w-1.5 h-1.5 rounded-full bg-brass pointer-events-none hidden md:block"
      />
    </>
  );
}
